export default {"src":"https://kroemtech.ch//_next/static/media/arrowsVertical2.0c3235a5.svg","height":230,"width":87,"blurWidth":0,"blurHeight":0};